<div class="label_properties">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div>
      <app-button-bar [items]="highlightedRows" [setButtons]="buttons" (buttonEmit)="$event.name === 'add' ? onAdd($event) : onRemove($event)"></app-button-bar>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="url">
          <th mat-header-cell *matHeaderCellDef>{{'general.url' | transloco}} </th>
          <td mat-cell matTooltip="" title="click to edit" class="textAlignLeft" *matCellDef="let element; let index = index">
            <editable (update)="inputEdited(index, element, $event)">
              <ng-template viewMode>
                {{element.url | PipeTruncate:['30']}}
              </ng-template>
              <ng-template editMode>
                <input inputrestriction="basic1" matTooltip="enter to finish" style="width: 100px !important;" #editInput value="" focusable editableOnEnter>
              </ng-template>
            </editable>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row (click)="onSelectedRow(row)" class="table-row" tabindex="1" *matRowDef="let row; columns: displayedColumns" [style.background]="highlightedRows.indexOf(row) > -1 ? 'var(--background-default2)' : ''"></tr>
      </table>
      <br/>
      <br/>
      <br/>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
    </div>
  }
</div>
